<template>
<div class="animated fadeIn">
  <b-card no-body>
    <b-card-body>
      <b-row>
        <b-col lg="12">
          <!--<h6>Simple Form</h6>-->
          <b-form v-on:submit.prevent="onSubmit" v-on:reset.prevent="onReset" novalidate>

            <b-form-group label="Name" label-for="buildingName">
              <b-form-input id="name" type="text" aria-describedby="liveFeedbackName" v-model.lazy.trim="$v.form.name.$model" placeholder="Building Name" autofocus />
              <b-form-invalid-feedback id="liveFeedbackName">
                This is a required field.
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Address" label-for="buildingName">
              <b-form-input id="address" type="text" aria-describedby="liveFeedbackAddress" v-model.lazy.trim="$v.form.address.$model" placeholder="Building Address" />
              <b-form-invalid-feedback id="liveFeedbackAddress">
                This is a required field.
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Manager" label-for="manager">
              <b-form-input id="manager" type="text" aria-describedby="liveFeedbackManager" v-model.lazy.trim="$v.form.manager.$model" placeholder="Manager's Name" />
              <b-form-invalid-feedback id="liveFeedbackManager">
                This is a required field.
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Phone Number" label-for="phone">
              <b-form-input id="phone" type="text" aria-describedby="liveFeedbackPhone" v-model.lazy.trim="$v.form.phone.$model" placeholder="Building's Phone Number" />
              <b-form-invalid-feedback id="liveFeedbackPhone">
                This is a required field.
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label-for="is_active">
              <b-form-checkbox v-model="$v.form.is_active.$model" value="1" unchecked-value="0">Is Active</b-form-checkbox>
            </b-form-group>

            <b-button type="submit" variant="primary" :disabled="$v.form.$invalid">
              Submit
            </b-button>
            <b-button class="ml-1" type="reset" @click="onCancel">Cancel</b-button>
          </b-form>
          <br />
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</div>
</template>

<script>
import Vue from 'vue'
import {
  mapState,
  mapActions
} from 'vuex'
import {
  required
} from "vuelidate/lib/validators"

const formShape = {
  name: "",
  address: "",
  manager: "",
  phone: "",
  is_active: false
}

export default {
  name: "BuildingFormEdit",
  props: {
    building: Object
  },
  data() {
    return {
      form: Object.assign({}, formShape),
      submitted: false
    }
  },
  computed: {
    isValid() {
      return !this.$v.form.$anyError
    },
    isDirty() {
      return this.$v.form.$anyDirty
    },
    BuildingTypeList() {
      let list = []
      Vue._.forEach(this.$store.state.BuildingTypes.all, (BuildingType) => {
        list.push({
          label: BuildingType.Buildingtypename,
          value: BuildingType.Buildingtypeid
        })
      })
      return list
    },
  },
  validations: {
    form: {
      name: {
        required
      },
      address: {
        required
      },
      manager: {
        required
      },
      phone: {
        required
      },
      is_active: {
        required
      }
    }
  },
  methods: {
    onSubmit() {
      if (this.validate()) {
        this.$nextTick(() => {
          this.submitted = true
          let params = {
            id: this.building.id,
            name: this.$v.form.name.$model,
            address: this.$v.form.address.$model,
            manager: this.$v.form.manager.$model,
            phone: this.$v.form.phone.$model,
            is_active: this.$v.form.is_active.$model,
          }
          this.$store.dispatch('buildings/editBuilding', params)
            .then(() => {
              this.$emit('success')
              this.showSuccessMsg()
            })
            .catch((error) => {
              if (error.response.status == 400) {
                this.showErrorMsg({
                  message: error.response.data.message
                })
              } else {
                this.showErrorMsg()
              }
            })
        })
      }
    },
    onCancel() {
      this.$emit('cancel')
    },
    onReset() {
      // Reset validation
      this.form = formShape
      this.submitted = false
      this.$nextTick(() => {
        this.$v.$reset()
      })
    },
    chkState(val) {
      const field = this.$v.form[val]
      return field.$dirty ? !field.$invalid : null
    },
    findFirstError(component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    validate() {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    }
  },
  beforeMount() {
    this.form.name = this.building.name
    this.form.address = this.building.address
    this.form.manager = this.building.manager
    this.form.phone = this.building.phone
    this.form.is_active = this.building.is_active
  }
}
</script>
